// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-radio-group {
  width: 100%;
  border-radius: 5px;
  padding: 5px;
  display: block;
}
ion-radio-group ion-item {
  background: #ffffff;
  border-radius: var(--radius-default);
  border-bottom: var(--outline-default);
  margin-bottom: 5px;
}
ion-radio-group ion-item:first-child {
  border-top: var(--outline-default);
}

.price {
  font-size: 14px;
  color: var(--ion-color-black);
  font-weight: 400;
  text-align: end;
}

ion-label {
  font-size: 14px;
  text-transform: uppercase;
}

ion-icon {
  color: var(--ion-color-primary);
  height: 20px;
  width: 20px;
}

app-tag {
  display: inline-block;
}

.pfand {
  font-size: 10px;
}

ion-checkbox {
  --background: transparent;
  --background-checked: var(--ion-color-primary);
  --border-color: #3C3C3B;
  --border-color-checked: var(--ion-color-primary);
  --border-width: 1px;
  --checkmark-color: var(--ion-color-secondary);
  --checkmark-width: 3px;
  --border-radius: 3px;
  --size: 20px;
}

ion-checkbox::part(container) {
  background: transparent;
}

ion-checkbox.checkbox-checked::part(container) {
  background: var(--ion-color-primary);
  border-color: var(--ion-color-primary);
}

ion-checkbox.checkbox-checked::part(mark) {
  color: #0f2a18;
}`, "",{"version":3,"sources":["webpack://./src/app/components/article-option-group-checkbox/article-option-group-checkbox.component.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;AACD;AACC;EACC,mBAAA;EACA,oCAAA;EACA,qCAAA;EACM,kBAAA;AACR;AACE;EACC,kCAAA;AACH;;AAIA;EACC,eAAA;EACA,6BAAA;EACA,gBAAA;EACA,eAAA;AADD;;AAIA;EACC,eAAA;EACA,yBAAA;AADD;;AAIA;EACC,+BAAA;EACA,YAAA;EACA,WAAA;AADD;;AAIA;EACC,qBAAA;AADD;;AAIA;EACC,eAAA;AADD;;AAIA;EACI,yBAAA;EACA,8CAAA;EACA,uBAAA;EACA,gDAAA;EACA,mBAAA;EACA,6CAAA;EACA,sBAAA;EACA,oBAAA;EACA,YAAA;AADJ;;AAIA;EACC,uBAAA;AADD;;AAIA;EACE,oCAAA;EACA,sCAAA;AADF;;AAIA;EACC,cAAA;AADD","sourcesContent":["ion-radio-group {\n\twidth: 100%;\n\tborder-radius: 5px;\n\tpadding: 5px;\n\tdisplay: block;\n\n\tion-item {\n\t\tbackground: #ffffff;\n\t\tborder-radius: var(--radius-default);\n\t\tborder-bottom: var(--outline-default);\n        margin-bottom: 5px;\n\n\t\t&:first-child {\n\t\t\tborder-top: var(--outline-default);\n\t\t}\n\t}\n}\n\n.price {\n\tfont-size: 14px;\n\tcolor: var(--ion-color-black);\n\tfont-weight: 400;\n\ttext-align: end;\n}\n\nion-label {\n\tfont-size: 14px;\n\ttext-transform: uppercase;\n}\n\nion-icon {\n\tcolor: var(--ion-color-primary);\n\theight: 20px;\n\twidth: 20px;\n}\n\napp-tag {\n\tdisplay: inline-block;\n}\n\n.pfand {\n\tfont-size: 10px;\n}\n\nion-checkbox {\n    --background: transparent;\n    --background-checked: var(--ion-color-primary);\n    --border-color: #3C3C3B;\n    --border-color-checked: var(--ion-color-primary);\n    --border-width: 1px;\n    --checkmark-color: var(--ion-color-secondary);\n    --checkmark-width: 3px;\n    --border-radius: 3px;\n    --size: 20px;\n}\n\nion-checkbox::part(container) {\n\tbackground: transparent;\n}\n\nion-checkbox.checkbox-checked::part(container) {\n  background: var(--ion-color-primary);\n  border-color: var(--ion-color-primary);\n}\n\nion-checkbox.checkbox-checked::part(mark) {\n\tcolor: #0f2a18;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
